import { Button } from '@mui/material';
import { useGlobalStore } from '../../application/store/store.tsx';

const MessagePage = () => {
    const setMessage = useGlobalStore((state) => state.setMessage);

    return (
        <div className="flex flex-col items-center">
            <h1 className="text-3xl">Message page</h1>
            <div className={'flex space-x-4 translate-y-28'}>
                <Button
                    variant="contained"
                    color="success"
                    onClick={() => setMessage('This is good', 'success', 5000)}
                >
                    Success
                </Button>
                <Button
                    variant="contained"
                    color="error"
                    onClick={() => setMessage('This is bad', 'error', 5000)}
                >
                    Error
                </Button>
                <Button
                    variant="contained"
                    color="warning"
                    onClick={() =>
                        setMessage('This is a warning', 'warning', 5000)
                    }
                >
                    Warning
                </Button>
                <Button
                    variant="contained"
                    color="info"
                    onClick={() => setMessage('This is Info', 'info', 5000)}
                >
                    Info
                </Button>
            </div>
        </div>
    );
};

export default MessagePage;
